const API_URL_EXTERNAL = `https://${window.location.hostname}`;
const API_URL = process.env.REACT_APP_API_URL ?  process.env.REACT_APP_API_URL : API_URL_EXTERNAL;
const ON_DEV_ENV = process.env.NODE_ENV ? process.env.NODE_ENV === 'development' : false;

const API_PATHS = {
	boards: 'boards',
    habits: 'habits',
    workouts: 'workouts',
    todos: 'todos',
    register: 'register',
    login: 'login',
    user: 'user',
    wLogs: 'wlogs',
    notes: 'notes',
    habit: 'habit',
    tasks: 'tasks',
    board: 'board',
    budget: 'budget',
}

const API_ENDS = {
    get: 'get',
    update: 'update',
    delete: 'delete',
    new: 'new',
    updateStreak: 'updateStreak',
    markWorkoutDone: 'markToday',
    markToDoItemDone: 'markDone',
    login: 'login',
    newToDoItem: 'newToDoItem',
    editToDoItem: 'editToDoItem',
    deleteToDoItem: 'deleteToDoItem',
    edit: 'edit',
    restart: 'restart',
    week: 'week',
    targetWeek: 'targetWeek',
    day: 'day',
    settings: 'settings',
    visibility: 'visibility',
    types: 'types',
    order: 'order'
}

const USER_TOKEN_FIELD_NAME = 'x-access-token';
const USER_STORAGE_FIELD_NAME = 'user';
const USER_TOKEN_INVALID_MESSAGE = 'Invalid token';
const USER_TOKEN_INVALID_RELOADING_MESSAGE = 'Invalid user token <br> Reloading to login';
const USER_TOKEN_EXPIRY_IN_DAYS = 730;
const TOKEN_COOKIE_OPTIONS =  { 
    expires: USER_TOKEN_EXPIRY_IN_DAYS,
    secure: !ON_DEV_ENV,
    // httpOnly: !ON_DEV_ENV,
    httpOnly: false,
    sameSite: 'Strict'
};

const COLLAPSED_ITEMS_FIELD_NAME = 'collapsedToDoItems';

const BUTTON_TITLES = {
    doneButtonText: 'Mark Done',
    markToday: 'Mark Today',
    today: 'Today',
    startToday: 'Start Today',
    restart: 'Restart',
}

const ONE_DAY = (1000 * 60 * 60 * 24);

const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const MONTH_NAMES = [
    "January", "February", "March", "April", 
    "May", "June", "July", "August", 
    "September", "October", "November", "December"
];


const LONG_MONTHS = [1, 3, 5, 7, 8, 10, 12];

const LABELS = {
    appName: 'Reliant Steps',
    edit: 'Editing',
	new: 'Add New',
	apiError: 'Unable to fetch from API',
    username: 'Username',
    password: 'Password',
    loginForm: 'Login Form',
    loginBtn: 'Login',
    wLogFormInstructions: 'Enter value',
    wLogValuePlaceHolder: '155',
    toDoItemContent: 'e.g. Pickup dry cleaning',
    endDate: 'End Date',
    startDate: 'Start Date',
    today: 'Today',
    titlePlaceholder: 'Title',
    priorityPlaceholder: 'Priority',
    showForm: 'Show Form',
    addNew: 'Add New',
    newNote: 'Note',
    newToDo: 'To Do',
    newHabit: 'Habit',
    newSpending: 'Spending',
    newWorkout: 'Workout',
    newBoard: 'Board',
    createNew: 'Create New',
    save: 'Save',
    discard: 'Discard',
    addItem: 'Item',
    noteBodyPlaceholder: 'Note content',
    confirmDialogTitle: 'Confirm',
    confirm: 'Confirm',
    confirmQuestion: 'Are you sure?',
    confirmDelete: 'Are you sure you want to delete?',
    cancel: 'Cancel',
    dismiss: 'Dismiss',
    message: 'Message',
    messageDialogMessage: 'You\'ve got mail!',
    habitTitlePlaceholder: 'e.g. Read',
    duration: 'Duration',
    noTasksForToday: 'No tasks for today',
    noTasksForThisDay: 'No tasks for this day',
    boardType: 'Board Type',
    loadMore: 'Load More',
    unitPlaceholder: 'Unit e.g $, lbs, kg',
    unitSuffixPlaceholder: 'Unit is suffix?',
    shouldTallyPlaceholder: 'Tally logs?',
    descriptionPlaceholder: 'Description',
    spendingAmountPlaceholder: '$30.00',
    spendingDate: 'Date',
    category: 'Category',
    none: 'None',
    total: 'Total',
    budgetTallyDivider: 'of',
    categoryFilter: 'Category Filter',
    categoryEmpty: 'Category is empty',
    noSpendingLogs: 'No logs for this month',
}

const UTILITY_CSS_CLASSES = {
	hidden: 'hidden',
	invisible: 'invisible',
	inactive: 'inactive',
	expanded: 'expanded',
    expanding: 'expanding',
	editing: 'editing',
	overlay: 'overlay',
	notValid: 'not-valid',
	highlight: 'highlight',
    hasErrors: 'has-errors',
    dateApproaching: 'date--approaching',
    datePassed: 'date--passed',
    dateToday: 'date--today',
    toggled: 'toggled',
    hasAction: 'has-action',
    fixed: 'fixed',
    onIOSWebApp: 'on-ios-webapp',
    onSafari: 'on-safari',
    reloading: 'reloading',
    reloadAnimation: 'loading-rotate',
    orderMode: 'order-mode',
    show: 'show',
    toastDialog: 'modal--toast',
}

const EVENTS = {
    update: "update",
    reload: "reload",
    boardVisibility: 'boardVisibility',
    boardOrder: 'boardOrder',
    boardEdit: 'boardEdit',
    boardNew: 'boardNew',
    new: "new",
    edit: "edit",
    delete: "delete",
    toDoOrder: 'toDoOrder',
}

const FORM_MESSAGES = {
    usernameRequired: 'Username is required',
    usernameInvalid: 'Username has invalid characters',
    passwordRequired: 'Password is required',
    loginSubmit: 'Submitting Form',
    failedSubmit: 'Submit Failed',
    valueRequired: 'Value is required',
    valueInvalid: 'Value has invalid characters',
    createdNewWLog: 'New WLog created',
    newWLogSubmit: 'Creating WLog',
    contentRequired: 'Content is required',
    newToDoItemSubmit: 'Creating ToDo Item',
    createdNewToDoItem: 'ToDo Item Created',
    editToDoItemSubmit: 'Saving ToDo Item...',
    savedToDoItem: 'ToDo Item saved',
    deletedToDoItem: 'ToDo Item deleted',
    titleInvalid: 'Title is invalid',
    titleRequired: 'Title is required',
    bodyRequired: 'Body is required',

    
    noteFormInstructions: 'Enter Note details',
    noteEdit: 'Editing Note',
    createdNewNote: 'Note Created',
    newNoteSubmit: 'Creating Note',
    deletedNote: 'Note deleted',
    editNoteSubmit: 'Saving Note...',
    savedNote: 'Note saved',

    habitFormInstructions: 'Enter Habit details',
    habitEdit: 'Editing Habit',
    createdNewHabit: 'Habit Created',
    newHabitSubmit: 'Creating Habit...',
    editHabitSubmit: 'Saving Habit...',
    savedHabit: 'Habit saved',
    deletedHabit: 'Habit deleted',
    startDateRequired: 'Start Date Required',
    durationRequired: 'Duration required',
    durationInvalid: 'Duration cannot be zero',

    toDoFormInstructions: 'Enter ToDo details',
    toDoEdit: 'Editing ToDo',
    newToDoSubmit: 'Creating ToDo...',
    createdNewToDo: 'ToDo created',
    editToDoSubmit: 'Saving ToDo...',
    savedToDo: 'ToDo saved',
    deletedToDo: 'ToDo deleted',

    toDoItemFormInstructions: 'Enter ToDo Item details',
    toDoItemEdit: 'Editing ToDo Item',
    
    spendingFormInstructions: 'Enter Spending Details',
    spendingEdit: 'Editing Spending',

    boardFormInstructions: 'Enter Board details',
    boardEdit: 'Editing Board',
    editBoardSubmit: 'Saving Board...',
    savedBoard: 'Board saved',
    deletedBoard: 'Board deleted',
    newBoardSubmit: 'Creating Board...',
    typeRequired: 'Type is required',
    createdNewBoard: 'Board Created',

    logIntroFormInstructions: 'Set Budget',
    logIntroEdit: 'Editing Settings',
    logIntroFormSubmit: 'Saving Settings...',
    logIntroFormSuccess: 'Settings Saved',
    newSpendingSubmit: 'Logging Spending...',
    newSpendingSuccess: 'Logged Spending',
    saveSpendingSubmit: 'Updating Spending',
    saveSpendingSuccess: 'Spending saved',
    amountRequired: 'Amount Required',
    descriptionRequired: 'Description Required',
    categoryRequired: 'Category Required',

    loginFormInstructions: 'Enter username and password',
}

const BOARD_TYPES = {
    notes: 'Notes',
    workouts: 'Workouts',
    habits: 'Habits',
    wlogs: 'WLogs',
    notes: 'Notes',
    todo: 'ToDo',
    tasks: 'Tasks',
    budget: 'Budget',
}

const fadeOutAnimationDuration = 0.18 * 1000;
const FADEOUT_ANIMATION_DELAY = 0.5 * 1000;
const FADEOUT_DURATION = fadeOutAnimationDuration + FADEOUT_ANIMATION_DELAY;
const POST_LOGIN_RELOAD_DELAY = FADEOUT_DURATION + (FADEOUT_DURATION / 2);
const DELETE_SUCCESS_FADEOUT_DURATION = FADEOUT_DURATION;
const EDIT_MSG_FADEOUT = 920;
const GRACEFUL_FINALLY_DELAY = 500;
const MESSAGE_DIALOG_FADEOUT = 3 * 1000;

export {
    API_URL,
    API_ENDS,
    API_PATHS,
    USER_TOKEN_FIELD_NAME,
    USER_STORAGE_FIELD_NAME,
    USER_TOKEN_INVALID_MESSAGE,
    USER_TOKEN_INVALID_RELOADING_MESSAGE,
    USER_TOKEN_EXPIRY_IN_DAYS,
    TOKEN_COOKIE_OPTIONS,
    COLLAPSED_ITEMS_FIELD_NAME,
    BUTTON_TITLES,
    ONE_DAY,
    DAY_NAMES,
    MONTH_NAMES,
    LONG_MONTHS,
    LABELS,
    POST_LOGIN_RELOAD_DELAY,
    UTILITY_CSS_CLASSES,
    FORM_MESSAGES,
    MESSAGE_DIALOG_FADEOUT,
    DELETE_SUCCESS_FADEOUT_DURATION,
    EDIT_MSG_FADEOUT,
    GRACEFUL_FINALLY_DELAY,
    EVENTS,
    BOARD_TYPES
}